import { CookieVariation } from 'constants/cookiesEnums';
import { LOCALES } from 'lang/locales';

export enum CheckoutMessages {
    // Global
    TITLE = 'checkout.title',
    TITLE_UPGRADE = 'checkout.title.upgrade',
    TITLE_SIX_MONTHS = 'checkout.title.sixMonths',

    // My plan
    CARD_PLAN_TITLE = 'checkout.card.plan.title',
    CARD_PLAN_SUBTITLE = 'checkout.card.plan.subtitle',
    CARD_PLAN_NAME = 'checkout.card.plan.name',
    CARD_PLAN_INCLUDES_PAGES = 'checkout.card.plan.includesPages',
    CARD_PLAN_MORE_PAPER = 'checkout.card.plan.morePaper',
    CARD_PLAN_VIEW_PLANS = 'checkout.card.plan.viewPlans',

    // Common

    CARD_COMMON_ZIP = 'checkout.common.zip',
    CARD_COMMON_STATE = 'checkout.common.state',
    CARD_COMMON_CITY = 'checkout.common.city',
    CARD_COMMON_ADDRESS_ONE = 'checkout.common.address.one',
    CARD_COMMON_ADDRESS_TWO = 'checkout.common.address.two',
    CARD_COMMON_OPTIONAL = 'checkout.common.optional',

    CARD_COMMON_ZIP_ERROR = 'checkout.common.zip.error',
    CARD_COMMON_ZIP_ERROR_BLACKLIST = 'checkout.common.zip.error.blacklist',
    CARD_COMMON_ZIP_UNAVAILABLE = 'checkout.common.zip.error.unavailable',
    CARD_COMMON_ZIP_ERROR_INVALID_FORMAT = 'checkout.common.zip.error.invalidFormat',
    CARD_COMMON_ZIP_ERROR_MAXLENGTH = 'checkout.common.zip.error.maxLength',
    CARD_COMMON_STATE_ERROR = 'checkout.common.state.error',
    CARD_COMMON_CITY_ERROR = 'checkout.common.city.error',
    CARD_COMMON_ADDRESS_ONE_ERROR = 'checkout.common.address.one.error',

    // Shipping
    CARD_SHIPPING_TITLE = 'checkout.shipping.title',
    CARD_SHIPPING_RETAIL_TITLE = 'checkout.shipping.title.retail',
    CARD_SHIPPING_SUBTITLE = 'checkout.shipping.subtitle',
    CARD_SHIPPING_SUBTITLE_UPGRADE = 'checkout.shipping.subtitle.upgrade',
    CARD_SHIPPING_RETAIL_FORM_SUBTITLE = 'checkout.shipping.retail.subtitle',
    CARD_SHIPPING_TITLE_TWODAYSHIPPING = 'checkout.shipping.title.twoDayShipping',
    CARD_SHIPPING_SUBTITLE_TWODAYSHIPPING = 'checkout.shipping.subtitle.twoDayShipping',
    CARD_SHIPPING_SERIAL_NUMBER = 'checkout.shipping.serialNumber',
    CARD_SHIPPING_ADDSHIPPING = 'checkout.shipping.addShipping',
    CARD_SHIPPING_ADDDETAILS = 'checkout.shipping.addDetails',

    CARD_SHIPPING_FORM_TITLE = 'buyflow.shippingCard.form.title',
    CARD_SHIPPING_FORM_RETAIL_TITLE = 'buyflow.shippingCard.form.title.retail',
    CARD_SHIPPING_FORM_SUBTITLE = 'buyflow.shippingCard.form.subtitle',
    CARD_SHIPPING_FORM_SUBTITLE_UPGRADE = 'buyflow.shippingCard.form.subtitle.upgrade',
    CARD_SHIPPING_FORM_MOBILE_NUMBER = 'buyflow.shippingCard.form.mobileNumber',
    CARD_SHIPPING_FORM_SERIAL_NUMBER = 'buyflow.shippingCard.form.serialNumber',
    CARD_SHIPPING_FORM_SERIAL_NUMBER_EXAMPLE = 'buyflow.shippingCard.form.serialNumber.example',
    CARD_SHIPPING_FORM_EMAIL = 'buyflow.shippingCard.form.email',
    CARD_SHIPPING_FORM_COMPANY = 'buyflow.shippingCard.form.company',
    CARD_SHIPPING_FORM_LAST_NAME = 'buyflow.shippingCard.form.lastName',
    CARD_SHIPPING_FORM_FIRST_NAME = 'buyflow.shippingCard.form.firstName',
    CARD_SHIPPING_FORM_NO_PO_BOXES = 'buyflow.shippingCard.form.poBox',

    CARD_SHIPPING_FORM_EMAIL_ERROR = 'buyflow.shippingCard.form.email.error',
    CARD_SHIPPING_FORM_EMAIL_ERROR_FORMAT = 'buyflow.shippingCard.form.email.error.format',
    CARD_SHIPPING_FORM_SERIAL_NUMBER_ERROR = 'buyflow.shippingCard.form.serialNumber.error',
    CARD_SHIPPING_FORM_MOBILE_PHONE_ERROR = 'buyflow.shippingCard.form.mobileNumber.error',
    CARD_SHIPPING_FORM_MOBILE_ERROR_PHONE_NUMBER_BELOW_ZERO = 'buyflow.shippingCard.form.mobileNumber.error.belowZero',
    CARD_SHIPPING_FORM_LAST_NAME_ERROR = 'buyflow.shippingCard.form.lastName.error',
    CARD_SHIPPING_FORM_FIRST_NAME_ERROR = 'buyflow.shippingCard.form.firstName.error',

    // Billing
    CARD_BILLING_TITLE = 'checkout.billing.title',
    CARD_BILLING_SUBTITLE = 'checkout.billing.subtitle',
    CARD_BILLING_SUBTITLE_UPGRADE = 'checkout.billing.subtitle.upgrade',
    CARD_BILLING_SUBTITLE_ACTIVATION = 'checkout.billing.subtitle.activation',
    CARD_BILLING_PAYPAL = 'checkout.billing.paypal',
    CARD_BILLING_LAST_FOUR = 'checkout.billing.lastFour',
    CARD_BILLING_EXPIRES = 'checkout.billing.expires',
    CARD_BILLING_ADDBILLING = 'checkout.billing.addBilling',

    CARD_BILLING_FORM_TITLE = 'checkout.billing.form.title',
    CARD_BILLING_FORM_SUBTITLE = 'checkout.billing.form.subTitle',
    CARD_BILLING_FORM_CCINFO = 'checkout.billing.form.ccInfo',
    CARD_BILLING_FORM_NAME = 'checkout.billing.form.name',
    CARD_BILLING_FORM_NAME_ERROR = 'checkout.billing.form.name.error',
    CARD_BILLING_FORM_BILLING_ADDRESS = 'checkout.billing.form.billingAddress',
    CARD_BILLING_FORM_USE_SHIPPING_ADDRESS = 'checkout.billing.form.useShippingAddress',
    CARD_BILLING_FORM_GENERAL_ERROR = 'checkout.billing.form.generalError',

    CARD_BILLING_STRIPE_GENERAL_ERROR = 'checkout.billing.stripe.generalError',
    CARD_BILLING_STRIPE_INVALID_FUNDING_ERROR = 'checkout.billing.stripe.invalidFundingError',
    CHECKOUT_FAILED_POST = 'checkout.post.error',

    // Automatic Renewal Notice
    ARN_TITLE = 'checkout.arn.title',
    ARN_CONFIRMATION_LABEL = 'checkout.arn.confirmationLabel',
    ARN_CONFIRMATION_LINK = 'checkout.arn.confirmationLink',
    ARN_BODY = 'checkout.arn.body',
    ARN_BODY_NO_OJP = 'checkout.arn.body.noOjp',
    ARN_BODY_ACTIVATION = 'checkout.arn.body.activation',
    ARN_BODY_UPGRADE = 'checkout.arn.body.upgrade',
    ARN_COMPLETE = 'checkout.arn.body.complete',
    ARN_COMPLETE_UPGRADE = 'checkout.arn.body.complete.upgrade',

    // Survey Modal
    SURVEY_TITLE = 'checkout.survey.title',
    SURVEY_SUBTITLE = 'checkout.survey.subtitle',
    SURVEY_BUTTON = 'checkout.survey.button',
    SURVEY_LINK = 'checkout.survey.link',
    SURVEY_GIFTCARD = 'checkout.survey.giftcard',

    // Shop Comparison

    SHOP_COMPARISON_TITLE = 'checkout.shopComparison.title',
    SHOP_COMPARISON_SUBSCRIBE_TITLE = 'checkout.shopComparison.subscribe.title',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_ONE = 'checkout.shopComparison.subscribe.itemOne',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_TWO = 'checkout.shopComparison.subscribe.itemTwo',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_THREE = 'checkout.shopComparison.subscribe.itemThree',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_FOUR = 'checkout.shopComparison.subscribe.itemFour',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_FIVE = 'checkout.shopComparison.subscribe.itemFive',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_SIX = 'checkout.shopComparison.subscribe.itemSix',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_SEVEN = 'checkout.shopComparison.subscribe.itemSeven',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_EIGHT = 'checkout.shopComparison.subscribe.itemEight',
    SHOP_COMPARISON_BUY_TITLE = 'checkout.shopComparison.buy.title',
    SHOP_COMPARISON_BUY_ITEM_ONE = 'checkout.shopComparison.buy.itemOne',
    SHOP_COMPARISON_BUY_ITEM_TWO = 'checkout.shopComparison.buy.itemTwo',
    SHOP_COMPARISON_BUY_ITEM_THREE = 'checkout.shopComparison.buy.itemThree',

    SAYAN_MODAL_TITLE = 'checkout.sayanModal.title',
    SAYAN_MODAL_CONTINUE_SUBSCRIPTION = 'checkout.sayanModal.continueSubscription',
    SAYAN_MODAL_CONTINUE_BUY = 'checkout.sayanModal.continueBuy',
    SAYAN_MODAL_BUTTON_BUY = 'checkout.sayanModal.buttonBuy',
    SAYAN_MODAL_DISCLAIMER = 'checkout.sayanModal.disclaimer',
    SAYAN_MODAL_CONTINUE_BUTTON = 'checkout.sayanModal.continueButton',
}

export enum CheckoutMessagesB {
    // Global
    TITLE = 'checkout.title',
    TITLE_UPGRADE = 'checkout.title.upgrade',
    TITLE_SIX_MONTHS = 'checkout.title.sixMonths',

    // My plan
    CARD_PLAN_TITLE = 'checkout.card.plan.title',
    CARD_PLAN_SUBTITLE = 'checkout.card.plan.subtitle',
    CARD_PLAN_NAME = 'checkout.card.plan.name',
    CARD_PLAN_INCLUDES_PAGES = 'checkout.card.plan.includesPages',
    CARD_PLAN_MORE_PAPER = 'checkout.card.plan.morePaper',
    CARD_PLAN_VIEW_PLANS = 'checkout.card.plan.viewPlans',

    // Common

    CARD_COMMON_ZIP = 'checkout.common.zip',
    CARD_COMMON_STATE = 'checkout.common.state',
    CARD_COMMON_CITY = 'checkout.common.city',
    CARD_COMMON_ADDRESS_ONE = 'checkout.common.address.one',
    CARD_COMMON_ADDRESS_TWO = 'checkout.common.address.two',
    CARD_COMMON_OPTIONAL = 'checkout.common.optional',

    CARD_COMMON_ZIP_ERROR = 'checkout.common.zip.error',
    CARD_COMMON_ZIP_ERROR_BLACKLIST = 'checkout.common.zip.error.blacklist',
    CARD_COMMON_ZIP_UNAVAILABLE = 'checkout.common.zip.error.unavailable',
    CARD_COMMON_ZIP_ERROR_INVALID_FORMAT = 'checkout.common.zip.error.invalidFormat',
    CARD_COMMON_ZIP_ERROR_MAXLENGTH = 'checkout.common.zip.error.maxLength',
    CARD_COMMON_STATE_ERROR = 'checkout.common.state.error',
    CARD_COMMON_CITY_ERROR = 'checkout.common.city.error',
    CARD_COMMON_ADDRESS_ONE_ERROR = 'checkout.common.address.one.error',

    // Shipping
    CARD_SHIPPING_TITLE = 'checkout.shipping.title',
    CARD_SHIPPING_RETAIL_TITLE = 'checkout.shipping.title.retail',
    CARD_SHIPPING_SUBTITLE = 'checkout.shipping.subtitle',
    CARD_SHIPPING_SUBTITLE_UPGRADE = 'checkout.shipping.subtitle.upgrade',
    CARD_SHIPPING_RETAIL_FORM_SUBTITLE = 'checkout.shipping.retail.subtitle',
    CARD_SHIPPING_TITLE_TWODAYSHIPPING = 'checkout.shipping.title.twoDayShipping',
    CARD_SHIPPING_SUBTITLE_TWODAYSHIPPING = 'checkout.shipping.subtitle.twoDayShipping',
    CARD_SHIPPING_SERIAL_NUMBER = 'checkout.shipping.serialNumber',
    CARD_SHIPPING_ADDSHIPPING = 'checkout.shipping.addShipping',
    CARD_SHIPPING_ADDDETAILS = 'checkout.shipping.addDetails',

    CARD_SHIPPING_FORM_TITLE = 'buyflow.shippingCard.form.title',
    CARD_SHIPPING_FORM_RETAIL_TITLE = 'buyflow.shippingCard.form.title.retail',
    CARD_SHIPPING_FORM_SUBTITLE = 'buyflow.shippingCard.form.subtitle',
    CARD_SHIPPING_FORM_SUBTITLE_UPGRADE = 'buyflow.shippingCard.form.subtitle.upgrade',
    CARD_SHIPPING_FORM_MOBILE_NUMBER = 'buyflow.shippingCard.form.mobileNumber',
    CARD_SHIPPING_FORM_SERIAL_NUMBER = 'buyflow.shippingCard.form.serialNumber',
    CARD_SHIPPING_FORM_SERIAL_NUMBER_EXAMPLE = 'buyflow.shippingCard.form.serialNumber.example',
    CARD_SHIPPING_FORM_EMAIL = 'buyflow.shippingCard.form.email',
    CARD_SHIPPING_FORM_COMPANY = 'buyflow.shippingCard.form.company',
    CARD_SHIPPING_FORM_LAST_NAME = 'buyflow.shippingCard.form.lastName',
    CARD_SHIPPING_FORM_FIRST_NAME = 'buyflow.shippingCard.form.firstName',
    CARD_SHIPPING_FORM_NO_PO_BOXES = 'buyflow.shippingCard.form.poBox',

    CARD_SHIPPING_FORM_EMAIL_ERROR = 'buyflow.shippingCard.form.email.error',
    CARD_SHIPPING_FORM_EMAIL_ERROR_FORMAT = 'buyflow.shippingCard.form.email.error.format',
    CARD_SHIPPING_FORM_SERIAL_NUMBER_ERROR = 'buyflow.shippingCard.form.serialNumber.error',
    CARD_SHIPPING_FORM_MOBILE_PHONE_ERROR = 'buyflow.shippingCard.form.mobileNumber.error',
    CARD_SHIPPING_FORM_MOBILE_ERROR_PHONE_NUMBER_BELOW_ZERO = 'buyflow.shippingCard.form.mobileNumber.error.belowZero',
    CARD_SHIPPING_FORM_LAST_NAME_ERROR = 'buyflow.shippingCard.form.lastName.error',
    CARD_SHIPPING_FORM_FIRST_NAME_ERROR = 'buyflow.shippingCard.form.firstName.error',

    // Billing
    CARD_BILLING_TITLE = 'checkout.billing.title',
    CARD_BILLING_SUBTITLE = 'checkout.billing.subtitle',
    CARD_BILLING_SUBTITLE_UPGRADE = 'checkout.billing.subtitle.upgrade',
    CARD_BILLING_SUBTITLE_ACTIVATION = 'checkout.billing.subtitle.activation',
    CARD_BILLING_PAYPAL = 'checkout.billing.paypal',
    CARD_BILLING_LAST_FOUR = 'checkout.billing.lastFour',
    CARD_BILLING_EXPIRES = 'checkout.billing.expires',
    CARD_BILLING_ADDBILLING = 'checkout.billing.addBilling',

    CARD_BILLING_FORM_TITLE = 'checkout.billing.form.title',
    CARD_BILLING_FORM_SUBTITLE = 'checkout.billing.form.subTitle',
    CARD_BILLING_FORM_CCINFO = 'checkout.billing.form.ccInfo',
    CARD_BILLING_FORM_NAME = 'checkout.billing.form.name',
    CARD_BILLING_FORM_NAME_ERROR = 'checkout.billing.form.name.error',
    CARD_BILLING_FORM_BILLING_ADDRESS = 'checkout.billing.form.billingAddress',
    CARD_BILLING_FORM_USE_SHIPPING_ADDRESS = 'checkout.billing.form.useShippingAddress',
    CARD_BILLING_FORM_GENERAL_ERROR = 'checkout.billing.form.generalError',

    CARD_BILLING_STRIPE_GENERAL_ERROR = 'checkout.billing.stripe.generalError',
    CARD_BILLING_STRIPE_INVALID_FUNDING_ERROR = 'checkout.billing.stripe.invalidFundingError',
    CHECKOUT_FAILED_POST = 'checkout.post.error',

    // Automatic Renewal Notice
    ARN_TITLE = 'checkout.arn.title',
    ARN_CONFIRMATION_LABEL = 'checkout.arn.confirmationLabel',
    ARN_CONFIRMATION_LINK = 'checkout.arn.confirmationLink',
    ARN_BODY = 'checkout.arn.body_b',
    ARN_BODY_NO_OJP = 'checkout.arn.body.noOjp',
    ARN_BODY_ACTIVATION = 'checkout.arn.body.activation',
    ARN_BODY_UPGRADE = 'checkout.arn.body.upgrade',
    ARN_COMPLETE = 'checkout.arn.body.complete',
    ARN_COMPLETE_UPGRADE = 'checkout.arn.body.complete.upgrade',

    // Survey Modal
    SURVEY_TITLE = 'checkout.survey.title',
    SURVEY_SUBTITLE = 'checkout.survey.subtitle',
    SURVEY_BUTTON = 'checkout.survey.button',
    SURVEY_LINK = 'checkout.survey.link',
    SURVEY_GIFTCARD = 'checkout.survey.giftcard',

    // Shop Comparison

    SHOP_COMPARISON_TITLE = 'checkout.shopComparison.title',
    SHOP_COMPARISON_SUBSCRIBE_TITLE = 'checkout.shopComparison.subscribe.title',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_ONE = 'checkout.shopComparison.subscribe.itemOne',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_TWO = 'checkout.shopComparison.subscribe.itemTwo',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_THREE = 'checkout.shopComparison.subscribe.itemThree',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_FOUR = 'checkout.shopComparison.subscribe.itemFour',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_FIVE = 'checkout.shopComparison.subscribe.itemFive',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_SIX = 'checkout.shopComparison.subscribe.itemSix',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_SEVEN = 'checkout.shopComparison.subscribe.itemSeven',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_EIGHT = 'checkout.shopComparison.subscribe.itemEight',
    SHOP_COMPARISON_BUY_TITLE = 'checkout.shopComparison.buy.title',
    SHOP_COMPARISON_BUY_ITEM_ONE = 'checkout.shopComparison.buy.itemOne',
    SHOP_COMPARISON_BUY_ITEM_TWO = 'checkout.shopComparison.buy.itemTwo',
    SHOP_COMPARISON_BUY_ITEM_THREE = 'checkout.shopComparison.buy.itemThree',

    SAYAN_MODAL_TITLE = 'checkout.sayanModal.title',
    SAYAN_MODAL_CONTINUE_SUBSCRIPTION = 'checkout.sayanModal.continueSubscription',
    SAYAN_MODAL_CONTINUE_BUY = 'checkout.sayanModal.continueBuy',
    SAYAN_MODAL_BUTTON_BUY = 'checkout.sayanModal.buttonBuy',
    SAYAN_MODAL_DISCLAIMER = 'checkout.sayanModal.disclaimer',
}

export enum CheckoutMessagesC {
    // Global
    TITLE = 'checkout.title',
    TITLE_UPGRADE = 'checkout.title.upgrade',
    TITLE_SIX_MONTHS = 'checkout.title.sixMonths',

    // My plan
    CARD_PLAN_TITLE = 'checkout.card.plan.title',
    CARD_PLAN_SUBTITLE = 'checkout.card.plan.subtitle',
    CARD_PLAN_NAME = 'checkout.card.plan.name',
    CARD_PLAN_INCLUDES_PAGES = 'checkout.card.plan.includesPages',
    CARD_PLAN_MORE_PAPER = 'checkout.card.plan.morePaper',
    CARD_PLAN_VIEW_PLANS = 'checkout.card.plan.viewPlans',

    // Common

    CARD_COMMON_ZIP = 'checkout.common.zip',
    CARD_COMMON_STATE = 'checkout.common.state',
    CARD_COMMON_CITY = 'checkout.common.city',
    CARD_COMMON_ADDRESS_ONE = 'checkout.common.address.one',
    CARD_COMMON_ADDRESS_TWO = 'checkout.common.address.two',
    CARD_COMMON_OPTIONAL = 'checkout.common.optional',

    CARD_COMMON_ZIP_ERROR = 'checkout.common.zip.error',
    CARD_COMMON_ZIP_ERROR_BLACKLIST = 'checkout.common.zip.error.blacklist',
    CARD_COMMON_ZIP_UNAVAILABLE = 'checkout.common.zip.error.unavailable',
    CARD_COMMON_ZIP_ERROR_INVALID_FORMAT = 'checkout.common.zip.error.invalidFormat',
    CARD_COMMON_ZIP_ERROR_MAXLENGTH = 'checkout.common.zip.error.maxLength',
    CARD_COMMON_STATE_ERROR = 'checkout.common.state.error',
    CARD_COMMON_CITY_ERROR = 'checkout.common.city.error',
    CARD_COMMON_ADDRESS_ONE_ERROR = 'checkout.common.address.one.error',

    // Shipping
    CARD_SHIPPING_TITLE = 'checkout.shipping.title',
    CARD_SHIPPING_RETAIL_TITLE = 'checkout.shipping.title.retail',
    CARD_SHIPPING_SUBTITLE = 'checkout.shipping.subtitle',
    CARD_SHIPPING_SUBTITLE_UPGRADE = 'checkout.shipping.subtitle.upgrade',
    CARD_SHIPPING_RETAIL_FORM_SUBTITLE = 'checkout.shipping.retail.subtitle',
    CARD_SHIPPING_TITLE_TWODAYSHIPPING = 'checkout.shipping.title.twoDayShipping',
    CARD_SHIPPING_SUBTITLE_TWODAYSHIPPING = 'checkout.shipping.subtitle.twoDayShipping',
    CARD_SHIPPING_SERIAL_NUMBER = 'checkout.shipping.serialNumber',
    CARD_SHIPPING_ADDSHIPPING = 'checkout.shipping.addShipping',
    CARD_SHIPPING_ADDDETAILS = 'checkout.shipping.addDetails',

    CARD_SHIPPING_FORM_TITLE = 'buyflow.shippingCard.form.title',
    CARD_SHIPPING_FORM_RETAIL_TITLE = 'buyflow.shippingCard.form.title.retail',
    CARD_SHIPPING_FORM_SUBTITLE = 'buyflow.shippingCard.form.subtitle',
    CARD_SHIPPING_FORM_SUBTITLE_UPGRADE = 'buyflow.shippingCard.form.subtitle.upgrade',
    CARD_SHIPPING_FORM_MOBILE_NUMBER = 'buyflow.shippingCard.form.mobileNumber',
    CARD_SHIPPING_FORM_SERIAL_NUMBER = 'buyflow.shippingCard.form.serialNumber',
    CARD_SHIPPING_FORM_SERIAL_NUMBER_EXAMPLE = 'buyflow.shippingCard.form.serialNumber.example',
    CARD_SHIPPING_FORM_EMAIL = 'buyflow.shippingCard.form.email',
    CARD_SHIPPING_FORM_COMPANY = 'buyflow.shippingCard.form.company',
    CARD_SHIPPING_FORM_LAST_NAME = 'buyflow.shippingCard.form.lastName',
    CARD_SHIPPING_FORM_FIRST_NAME = 'buyflow.shippingCard.form.firstName',
    CARD_SHIPPING_FORM_NO_PO_BOXES = 'buyflow.shippingCard.form.poBox',

    CARD_SHIPPING_FORM_EMAIL_ERROR = 'buyflow.shippingCard.form.email.error',
    CARD_SHIPPING_FORM_EMAIL_ERROR_FORMAT = 'buyflow.shippingCard.form.email.error.format',
    CARD_SHIPPING_FORM_SERIAL_NUMBER_ERROR = 'buyflow.shippingCard.form.serialNumber.error',
    CARD_SHIPPING_FORM_MOBILE_PHONE_ERROR = 'buyflow.shippingCard.form.mobileNumber.error',
    CARD_SHIPPING_FORM_MOBILE_ERROR_PHONE_NUMBER_BELOW_ZERO = 'buyflow.shippingCard.form.mobileNumber.error.belowZero',
    CARD_SHIPPING_FORM_LAST_NAME_ERROR = 'buyflow.shippingCard.form.lastName.error',
    CARD_SHIPPING_FORM_FIRST_NAME_ERROR = 'buyflow.shippingCard.form.firstName.error',

    // Billing
    CARD_BILLING_TITLE = 'checkout.billing.title',
    CARD_BILLING_SUBTITLE = 'checkout.billing.subtitle',
    CARD_BILLING_SUBTITLE_UPGRADE = 'checkout.billing.subtitle.upgrade',
    CARD_BILLING_SUBTITLE_ACTIVATION = 'checkout.billing.subtitle.activation',
    CARD_BILLING_PAYPAL = 'checkout.billing.paypal',
    CARD_BILLING_LAST_FOUR = 'checkout.billing.lastFour',
    CARD_BILLING_EXPIRES = 'checkout.billing.expires',
    CARD_BILLING_ADDBILLING = 'checkout.billing.addBilling',

    CARD_BILLING_FORM_TITLE = 'checkout.billing.form.title',
    CARD_BILLING_FORM_SUBTITLE = 'checkout.billing.form.subTitle',
    CARD_BILLING_FORM_CCINFO = 'checkout.billing.form.ccInfo',
    CARD_BILLING_FORM_NAME = 'checkout.billing.form.name',
    CARD_BILLING_FORM_NAME_ERROR = 'checkout.billing.form.name.error',
    CARD_BILLING_FORM_BILLING_ADDRESS = 'checkout.billing.form.billingAddress',
    CARD_BILLING_FORM_USE_SHIPPING_ADDRESS = 'checkout.billing.form.useShippingAddress',
    CARD_BILLING_FORM_GENERAL_ERROR = 'checkout.billing.form.generalError',

    CARD_BILLING_STRIPE_GENERAL_ERROR = 'checkout.billing.stripe.generalError',
    CARD_BILLING_STRIPE_INVALID_FUNDING_ERROR = 'checkout.billing.stripe.invalidFundingError',
    CHECKOUT_FAILED_POST = 'checkout.post.error',

    // Automatic Renewal Notice
    ARN_TITLE = 'checkout.arn.title',
    ARN_CONFIRMATION_LABEL = 'checkout.arn.confirmationLabel',
    ARN_CONFIRMATION_LINK = 'checkout.arn.confirmationLink',
    ARN_BODY = 'checkout.arn.body_c',
    ARN_BODY_NO_OJP = 'checkout.arn.body.noOjp',
    ARN_BODY_ACTIVATION = 'checkout.arn.body.activation',
    ARN_BODY_UPGRADE = 'checkout.arn.body.upgrade',
    ARN_COMPLETE = 'checkout.arn.body.complete',
    ARN_COMPLETE_UPGRADE = 'checkout.arn.body.complete.upgrade',

    // Survey Modal
    SURVEY_TITLE = 'checkout.survey.title',
    SURVEY_SUBTITLE = 'checkout.survey.subtitle',
    SURVEY_BUTTON = 'checkout.survey.button',
    SURVEY_LINK = 'checkout.survey.link',
    SURVEY_GIFTCARD = 'checkout.survey.giftcard',

    // Shop Comparison

    SHOP_COMPARISON_TITLE = 'checkout.shopComparison.title',
    SHOP_COMPARISON_SUBSCRIBE_TITLE = 'checkout.shopComparison.subscribe.title',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_ONE = 'checkout.shopComparison.subscribe.itemOne',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_TWO = 'checkout.shopComparison.subscribe.itemTwo',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_THREE = 'checkout.shopComparison.subscribe.itemThree',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_FOUR = 'checkout.shopComparison.subscribe.itemFour',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_FIVE = 'checkout.shopComparison.subscribe.itemFive',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_SIX = 'checkout.shopComparison.subscribe.itemSix',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_SEVEN = 'checkout.shopComparison.subscribe.itemSeven',
    SHOP_COMPARISON_SUBSCRIBE_ITEM_EIGHT = 'checkout.shopComparison.subscribe.itemEight',
    SHOP_COMPARISON_BUY_TITLE = 'checkout.shopComparison.buy.title',
    SHOP_COMPARISON_BUY_ITEM_ONE = 'checkout.shopComparison.buy.itemOne',
    SHOP_COMPARISON_BUY_ITEM_TWO = 'checkout.shopComparison.buy.itemTwo',
    SHOP_COMPARISON_BUY_ITEM_THREE = 'checkout.shopComparison.buy.itemThree',

    SAYAN_MODAL_TITLE = 'checkout.sayanModal.title',
    SAYAN_MODAL_CONTINUE_SUBSCRIPTION = 'checkout.sayanModal.continueSubscription',
    SAYAN_MODAL_CONTINUE_BUY = 'checkout.sayanModal.continueBuy',
    SAYAN_MODAL_BUTTON_BUY = 'checkout.sayanModal.buttonBuy',
    SAYAN_MODAL_DISCLAIMER = 'checkout.sayanModal.disclaimer',
}

export const CheckoutMessageTypes = {
    [CookieVariation.Control]: CheckoutMessages,
    [CookieVariation.PlusSayan]: CheckoutMessagesB,
    [CookieVariation.SayanReplacing]: CheckoutMessagesC,
    [CookieVariation.LEBI]: CheckoutMessagesC, // TODO: Add LEBI checkout messages
};

const ARN_BODY =
    'NOTHING DUE TODAY. Your billing method will not be charged today.<br></br> <empty></empty> 30-DAY RISK-FREE TRIAL. If you cancel your subscription within 30 days of signup and return the printer to HP within 30 days of canceling, you will not be charged anything. <br></br> <empty></empty> SERVICE START DATE. Your service will start when you complete your enrollment after receiving your printer. You must complete your enrollment within 30 days to avoid being charged for the printer ($160 for Envy, $200 for Envy Inspire, and $270 for OfficeJet Pro). <br></br> <empty></empty> AUTOMATIC RENEWAL. Once your service starts, it will automatically renew and continue indefinitely until you cancel. Your payment method on file will be automatically billed monthly at the end of each billing cycle. Your monthly charges will be based on the printer and plan you selected, reflected in the “Your Plan” section above, which includes a fixed charge for the pages included with your plan and a potential overage charge for pages you print in excess of your plan during the month. <br></br> <empty></empty> CHANGE OR CANCEL SERVICE. You can change or cancel the service at any time by visiting <a>www.hpinstantink.com</a>, signing in and selecting “Cancel” on your dashboard or by calling 1-888-447-0148. Your service will cancel effective the last day of your current billing cycle. After you cancel, HP will remotely disable the subscription cartridge, so you will no longer be able to print with it. There is no fee to cancel the service, as long as you return the printer to HP in an operable and undamaged condition within 30 days of the end of your current billing cycle. Failure to return the printer will result in you being charged an equipment fee of $160 (Envy), $200 (Envy Inspire), or $290 (OfficeJet Pro) if you cancel in the first year or $80 (Envy), $100 (Envy Inspire), or $145 (OfficeJet Pro) if you cancel after the first year. No refunds will be issued for any unused ink or toner.';

export const checkoutMessages = {
    [LOCALES.ENGLISH]: {
        // Global
        [CheckoutMessages.TITLE]: 'Enter your details to get started',
        [CheckoutMessages.TITLE_UPGRADE]:
            'Please confirm details to proceed with your upgrade.',
        [CheckoutMessages.TITLE_SIX_MONTHS]:
            'Enter your details to get started and get 6 months free',

        // My Plan
        [CheckoutMessages.CARD_PLAN_TITLE]: 'My Plan',
        [CheckoutMessages.CARD_PLAN_SUBTITLE]: 'Your plan costs:',
        [CheckoutMessages.CARD_PLAN_NAME]: 'HP Instant Ink Platinum:\n{plan}',
        [CheckoutMessages.CARD_PLAN_INCLUDES_PAGES]:
            'Includes {pages} pages/month',
        [CheckoutMessages.CARD_PLAN_MORE_PAPER]: 'Paper: {morePaper}',
        [CheckoutMessages.CARD_PLAN_VIEW_PLANS]: 'View Plans',

        // Common
        [CheckoutMessages.CARD_COMMON_ADDRESS_ONE]:
            'Street Address (PO Boxes are not accepted)',
        [CheckoutMessages.CARD_COMMON_ADDRESS_TWO]: 'Street Address 2',
        [CheckoutMessages.CARD_COMMON_CITY]: 'City',
        [CheckoutMessages.CARD_COMMON_STATE]: 'State',
        [CheckoutMessages.CARD_COMMON_ZIP]: 'Zip',
        [CheckoutMessages.CARD_COMMON_OPTIONAL]: 'Optional',

        // Shipping,
        [CheckoutMessages.CARD_SHIPPING_ADDSHIPPING]: 'Add Shipping',
        [CheckoutMessages.CARD_SHIPPING_ADDDETAILS]: 'Add Details',
        [CheckoutMessages.CARD_SHIPPING_TITLE]: 'Shipping',
        [CheckoutMessages.CARD_SHIPPING_RETAIL_TITLE]: 'My information',
        [CheckoutMessages.CARD_SHIPPING_SUBTITLE]:
            'Let us know where to ship your printer',
        [CheckoutMessages.CARD_SHIPPING_SUBTITLE_UPGRADE]:
            'Let us know where to ship your new printer',
        [CheckoutMessages.CARD_SHIPPING_RETAIL_FORM_SUBTITLE]:
            'Provide an address so that we can complete your purchase.',
        [CheckoutMessages.CARD_SHIPPING_TITLE_TWODAYSHIPPING]:
            'Free 2 Day Shipping',
        [CheckoutMessages.CARD_SHIPPING_SUBTITLE_TWODAYSHIPPING]:
            'Let us know where to ship your printer',
        [CheckoutMessages.CARD_SHIPPING_SERIAL_NUMBER]:
            'Serial Number: {serialNumber}',

        [CheckoutMessages.CARD_SHIPPING_FORM_TITLE]: 'Shipping',
        [CheckoutMessages.CARD_SHIPPING_FORM_RETAIL_TITLE]: 'My information',
        [CheckoutMessages.CARD_SHIPPING_FORM_SUBTITLE]:
            'Provide a shipping address, so we know where to send your printer.',
        [CheckoutMessages.CARD_SHIPPING_FORM_SUBTITLE_UPGRADE]:
            'Provide a shipping address, so we know where to send your new printer.',

        [CheckoutMessages.CARD_SHIPPING_FORM_FIRST_NAME]: 'First Name',
        [CheckoutMessages.CARD_SHIPPING_FORM_LAST_NAME]: 'Last Name',
        [CheckoutMessages.CARD_SHIPPING_FORM_COMPANY]: 'Company Name',
        [CheckoutMessages.CARD_SHIPPING_FORM_EMAIL]: 'Email',
        [CheckoutMessages.CARD_SHIPPING_FORM_MOBILE_NUMBER]: 'Mobile Number',
        [CheckoutMessages.CARD_SHIPPING_FORM_SERIAL_NUMBER]:
            'Printer Serial Number',
        [CheckoutMessages.CARD_SHIPPING_FORM_SERIAL_NUMBER_EXAMPLE]:
            'Ex. TH1CH4Z1GT',
        [CheckoutMessages.CARD_SHIPPING_FORM_NO_PO_BOXES]:
            'PO Boxes are not accepted',

        // Billing
        [CheckoutMessages.CARD_BILLING_TITLE]: 'Billing',
        [CheckoutMessages.CARD_BILLING_SUBTITLE]:
            'Your card will not be charged today. ',
        [CheckoutMessages.CARD_BILLING_SUBTITLE_UPGRADE]:
            'No payment at this time for the upgrade. Your monthly billing will continue at the rate shown.',
        [CheckoutMessages.CARD_BILLING_SUBTITLE_ACTIVATION]:
            'You will be charged only a $39 activation fee today. ',
        [CheckoutMessages.CARD_BILLING_ADDBILLING]: 'Add Billing',
        [CheckoutMessages.CARD_BILLING_PAYPAL]:
            'PayPal connected with the account:<b> {account} </b>',
        [CheckoutMessages.CARD_BILLING_LAST_FOUR]: 'XXXX-XXXX-XXXX-{last4}',
        [CheckoutMessages.CARD_BILLING_EXPIRES]: 'Expires: {month}/{year}',
        [CheckoutMessages.CARD_BILLING_FORM_TITLE]: 'Billing',
        [CheckoutMessages.CARD_BILLING_FORM_SUBTITLE]:
            'Enter your credit card information.',
        [CheckoutMessages.CARD_BILLING_FORM_CCINFO]: 'Credit Card Information',
        [CheckoutMessages.CARD_BILLING_FORM_NAME]: 'Name',
        [CheckoutMessages.CARD_BILLING_FORM_BILLING_ADDRESS]: 'Billing Address',
        [CheckoutMessages.CARD_BILLING_FORM_USE_SHIPPING_ADDRESS]:
            'Use shipping address',
        [CheckoutMessages.CARD_BILLING_STRIPE_GENERAL_ERROR]:
            "We're sorry, an error has occurred with your payment method. Please try again.",
        [CheckoutMessages.CARD_BILLING_STRIPE_INVALID_FUNDING_ERROR]:
            "Sorry this payment option isn't available. Credit and Prepaid cards are not accepted at this time. Please use a valid debit card.",

        // Automatic Renewal Notice
        [CheckoutMessages.ARN_BODY]: ARN_BODY,
        [CheckoutMessagesB.ARN_BODY]: ARN_BODY,
        [CheckoutMessagesC.ARN_BODY]: ARN_BODY,

        [CheckoutMessages.ARN_BODY_NO_OJP]: `
            <p>PRUEBA DE 30 DIAS SIN COMPROMISO. Si cancelas tu suscripción dentro de los 30 días posteriores al registro y devuelves la impresora a HP dentro de los 10 días posteriores a la cancelación, no se te cobrará ninguna cuota mensual y se te reembolsarán los 20€ que pagaste al registrarte.</p>
            <p>FECHA DE INICIO DEL SERVICIO. Tu servicio comenzará cuando completes tu inscripción después de recibir su impresora. Debe completar tu inscripción dentro de los 30 días para tu registro que te cobre por la impresora (90€ para Debes Envy, 130€ para registro Envy Inspire).</p>
            <p>RENOVACIÓN AUTOMÁTICA. Una vez que comience tu servicio, se renovará automáticamente y continuará indefinidamente hasta que lo canceles. Tu método de pago registrado se cargará automáticamente cada mes al final de cada ciclo de facturación. Tus cargos mensuales se basarán en la impresora y el plan que seleccionaste, reflejados en la sección “Tu plan" anterior, que incluye un cargo fijo por las páginas incluidas en tu plan y un posible cargo por exceso por las páginas que imprimas en  durante el mes.</p> 
            <p>CAMBIAR O CANCELAR EL SERVICIO. Puedes cancelar en cualquier momento. Nunca hay gastos de cancelación. Debes devolver la impresora a HP. Si no devuelve su impresora a HP dentro de los 10 días posteriores a la cancelación, se la cobrará una cuota por no devuelves to devolución. El cargo por la no devolución de la impresora durante el primer año es de 81€ si tienes una Envy, 117€ si tienes una Envy Inspire . Este cargo se reducirá progresivamente cada año en función del tiempo que lleves en el Servicio. Consulta los términos y condiciones para más información. Las cancelaciones que se produzcan en los 30 días siguientes a la inscripción serán efectivas inmediatamente. Las cancelaciones posteriores a los 30 días de la inscripción entrarán en vigor al final del ciclo de facturación actual. No se emitirán reembolsos por tinta o tóner no utilizados suscripción.</p>`,
        [CheckoutMessages.ARN_BODY_ACTIVATION]:
            'ACTIVATION FEE.  Your billing method will be charged the $39 printer activation fee today.  <br></br> <empty></empty>30-DAY RISK-FREE TRIAL.  If you cancel your subscription within 30 days of signup and return the printer to HP within 30 days of canceling, your printer activation fee will be refunded, and you will not be charged anything.<br></br> <empty></empty>SERVICE START DATE.  Your service will start when you complete your enrollment after receiving your printer. You must complete your enrollment within 30 days to avoid being charged for the printer ($160 for Envy, $200 for Envy Inspire, and $270 for OfficeJet Pro).<br></br> <empty></empty>AUTOMATIC RENEWAL.  Once your service starts, it will automatically renew and continue indefinitely until you cancel. Your payment method on file will be automatically billed monthly at the end of each billing cycle. Your monthly charges will be based on the printer and plan you selected, reflected in the “Your Plan” section above, which includes a fixed charge for the pages included with your plan and a potential overage charge for pages you print in excess of your plan during the month.<br></br> <empty></empty>NO FEE TO CHANGE OR CANCEL SERVICE. You can change or cancel the service at any time by visiting <a>www.hpinstantink.com</a>, signing in, and selecting ‘Cancel my Instant Ink Subscription’ on the ‘Change Plan’ page or by calling 1-888-447-0148. Your service will cancel effective the last day of your current billing cycle. After you cancel, HP will remotely disable the subscription cartridge so you will no longer be able to print with it. There is no fee to cancel the service, as long as you return the printer to HP in an operable and undamaged condition within 30 days of the end of your current billing cycle. Failure to return the printer will result in you being charged an equipment fee of $160 (Envy), $200 (Envy Inspire), or $290 (OfficeJet Pro) if you cancel in the first year or $80 (Envy), $100 (Envy Inspire), or $145 (OfficeJet Pro) if you cancel after the first year. No refunds will be issued for any unused ink or toner.',
        [CheckoutMessages.ARN_BODY_UPGRADE]:
            '<p><b>FIRST 30 DAYS.</b> Once you confirm your printer upgrade, your 24-month subscription will restart. You must complete your enrollment within 30 days to avoid being charged for the printer ($160 for Envy, $200 for Envy Inspire, and $270 for OfficeJet Pro). Complete enrollment by calling the support number at the bottom of this box.</p><p><b>AUTOMATIC RENEWAL.</b> Once your service starts, it will automatically renew and continue indefinitely until you cancel. Your payment method on file will be automatically billed monthly at the end of each bill cycle. Your monthly charges will be based on the printer you selected, your current plan reflected on the previous page as well as within your Dashboard, and lastly whether you have opted into the optional paper add-on. This includes a fixed charge for the pages included in your plan and a potential overage charge for pages you print in excess of your plan during the month.</p><p><b>CHANGE OR CANCEL SERVICE.</b> You can change or cancel the service at any time by visiting <a>www.hpinstantink.com</a>, signing in, and selecting “Cancel” on your dashboard or by calling support. Beyond the 30-day trial, your cancellation will go into effect on the last day of your current billing cycle. After you cancel, HP will remotely disable the subscription cartridge, so you will no longer be able to print with it. If you cancel within the first year, you will be charged an early cancelation fee of $160 for Envy, $200 for Envy Inspire, and $270 for OfficeJet Pro. If you cancel between the first and second year, you will be charged an early cancelation fee of $80 for Envy, $100 for Envy Inspire, and $135 for OfficeJet Pro. No refunds will be issued for any unused ink or toner.</p><p><b>Platinum support: 1-888-447-0148</b></p>',
        [CheckoutMessages.ARN_COMPLETE_UPGRADE]: 'Continue with Upgrade',
        [CheckoutMessages.ARN_CONFIRMATION_LABEL]:
            'I have read and agree to the ',
        [CheckoutMessages.ARN_CONFIRMATION_LINK]:
            'HP Instant Ink Platinum Terms of Service',
        [CheckoutMessages.ARN_TITLE]: 'Automatic Renewal Notice',
        [CheckoutMessages.ARN_COMPLETE]: 'Confirm Subscription',

        // Survey Modal
        [CheckoutMessages.SURVEY_TITLE]: 'Sorry to see you go.',
        [CheckoutMessages.SURVEY_SUBTITLE]:
            'Have a couple of minutes to give us feedback?',
        [CheckoutMessages.SURVEY_BUTTON]: 'Start Survey',
        [CheckoutMessages.SURVEY_LINK]: 'No Thanks',
        [CheckoutMessages.SURVEY_GIFTCARD]:
            'Win a giftcard of your choice for your responses.',

        // Error Messages

        [CheckoutMessages.CARD_SHIPPING_FORM_FIRST_NAME_ERROR]:
            'Please enter your first name',
        [CheckoutMessages.CARD_SHIPPING_FORM_LAST_NAME_ERROR]:
            'Please enter your last name',
        [CheckoutMessages.CARD_COMMON_ZIP_ERROR]: 'Please enter your zip code.',
        [CheckoutMessages.CARD_COMMON_ZIP_ERROR_INVALID_FORMAT]:
            'Please, enter a valid zip code.',
        [CheckoutMessages.CARD_COMMON_ZIP_ERROR_MAXLENGTH]:
            'Please enter your zip code.',
        [CheckoutMessages.CARD_COMMON_ZIP_ERROR_BLACKLIST]:
            'Sorry we do not ship to {zip}',
        [CheckoutMessages.CARD_COMMON_ZIP_UNAVAILABLE]:
            'Sorry we do not ship to this zip location',
        [CheckoutMessages.CARD_COMMON_STATE_ERROR]: 'Please choose a state.',
        [CheckoutMessages.CARD_COMMON_CITY_ERROR]: 'Please enter a city.',
        [CheckoutMessages.CARD_COMMON_ADDRESS_ONE_ERROR]:
            'Please enter an address.',
        [CheckoutMessages.CARD_SHIPPING_FORM_EMAIL_ERROR]:
            'Please enter your email',
        [CheckoutMessages.CARD_SHIPPING_FORM_EMAIL_ERROR_FORMAT]:
            'Please enter a valid email format. Special characters allowed',
        [CheckoutMessages.CARD_SHIPPING_FORM_MOBILE_PHONE_ERROR]:
            'Please enter your phone number',
        [CheckoutMessages.CARD_SHIPPING_FORM_SERIAL_NUMBER_ERROR]:
            "Please enter your printer's serial number",
        [CheckoutMessages.CARD_SHIPPING_FORM_MOBILE_ERROR_PHONE_NUMBER_BELOW_ZERO]:
            'Phone number cannot be a negative number',
        [CheckoutMessages.CARD_BILLING_FORM_NAME_ERROR]:
            'Please enter the name that appears on your card',
        [CheckoutMessages.CARD_BILLING_FORM_GENERAL_ERROR]:
            'There was an error processing your payment',
        [CheckoutMessages.CHECKOUT_FAILED_POST]:
            'There was an issue with your payment, please try with another credit or debit card or contact your bank for support',

        // Shop Comparison

        [CheckoutMessages.SHOP_COMPARISON_TITLE]: 'Compare ways to shop',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_TITLE]:
            'Instant Ink Platinum\nSubscription',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_ONE]:
            'Printer Included',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_TWO]:
            'Warranty never expires*',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_THREE]:
            'Support Mon-Sun',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_FOUR]:
            'Instant Ink subscription included',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_FIVE]: 'Free shipping',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_SIX]:
            'Elegibility to upgrade to new printer\nevery 3 years',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_SEVEN]:
            'Next business day printer\replacement',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_EIGHT]:
            '30 days to try it out',
        [CheckoutMessages.SHOP_COMPARISON_BUY_TITLE]: ' \nBuy',
        [CheckoutMessages.SHOP_COMPARISON_BUY_ITEM_ONE]:
            'Must purchase the printer',
        [CheckoutMessages.SHOP_COMPARISON_BUY_ITEM_TWO]: '1 year warranty',
        [CheckoutMessages.SHOP_COMPARISON_BUY_ITEM_THREE]: 'Support Mon-Fri',

        // Sayan printer not available
        [CheckoutMessages.SAYAN_MODAL_TITLE]:
            'The printer model is not yet\navailable through HP\nInstant Ink Platinum.',
        [CheckoutMessages.SAYAN_MODAL_CONTINUE_SUBSCRIPTION]:
            'If you are interested in an all-\ninclusive printer subscription,\nplease choose a different\nprinter.',
        [CheckoutMessages.SAYAN_MODAL_CONTINUE_BUY]:
            'If you are interested in\nbuying a Smart Tank,\ncheck it out on the HP\nstore.',
        [CheckoutMessages.SAYAN_MODAL_BUTTON_BUY]: 'Buy Printer',
        [CheckoutMessages.SAYAN_MODAL_DISCLAIMER]:
            'We are evaluating the inclusion of the HP Smart Tank 6502 printer in the HP Instant Ink Platinum printing subscription service.\n We are sorry for the inconvenience.',
        [CheckoutMessages.SAYAN_MODAL_CONTINUE_BUTTON]: 'CONTINUE',
    },
    [LOCALES.SPANISH]: {
        [CheckoutMessages.TITLE]: 'Introduce tu información para comenzar',
        [CheckoutMessages.TITLE_UPGRADE]:
            'Por favor, confirma los siguientes detalles para continuar con tu actualizacion.',
        [CheckoutMessages.TITLE_SIX_MONTHS]:
            'Ingresa tus datos para comenzar y obtener 6 meses gratis',

        [CheckoutMessages.CARD_PLAN_TITLE]: 'Mi Plan',
        [CheckoutMessages.CARD_PLAN_SUBTITLE]: 'El coste de tu plan:',
        [CheckoutMessages.CARD_PLAN_NAME]: 'HP Instant Ink Platinum:\n{plan}',
        [CheckoutMessages.CARD_PLAN_INCLUDES_PAGES]:
            'Incluye {pages} páginas/mes',
        [CheckoutMessages.CARD_PLAN_MORE_PAPER]: 'Papel: {morePaper}',
        [CheckoutMessages.CARD_PLAN_VIEW_PLANS]: 'Ver Planes',

        [CheckoutMessages.CARD_COMMON_ADDRESS_ONE]:
            'Nombre y número de la calle',
        [CheckoutMessages.CARD_COMMON_ADDRESS_TWO]:
            'Apto, suite, unidad o piso',
        [CheckoutMessages.CARD_COMMON_CITY]: 'Ciudad',
        [CheckoutMessages.CARD_COMMON_STATE]: 'Provincia',
        [CheckoutMessages.CARD_COMMON_ZIP]: 'Código Postal',
        [CheckoutMessages.CARD_COMMON_OPTIONAL]: 'Opcional',

        [CheckoutMessages.CARD_SHIPPING_ADDSHIPPING]: 'Agregar envío',
        [CheckoutMessages.CARD_SHIPPING_ADDDETAILS]: 'Agregar detalles',
        [CheckoutMessages.CARD_SHIPPING_TITLE]: 'Envío',
        [CheckoutMessages.CARD_SHIPPING_RETAIL_TITLE]: 'Mi información',
        [CheckoutMessages.CARD_SHIPPING_SUBTITLE]:
            'Déjanos saber donde podemos llevarte tu impresora. El envío está incluido',
        [CheckoutMessages.CARD_SHIPPING_SUBTITLE_UPGRADE]:
            'Déjanos saber donde podemos llevarte tu nueva impresora',
        [CheckoutMessages.CARD_SHIPPING_TITLE_TWODAYSHIPPING]:
            'Envío Gratuito en 2 Días',
        [CheckoutMessages.CARD_SHIPPING_SUBTITLE_TWODAYSHIPPING]:
            'Déjanos saber donde podemos llevarte tu impresora',
        [CheckoutMessages.CARD_SHIPPING_SERIAL_NUMBER]: `Número de serie: {serialNumber}`,

        [CheckoutMessages.CARD_SHIPPING_FORM_TITLE]: 'Envío',
        [CheckoutMessages.CARD_SHIPPING_FORM_RETAIL_TITLE]: 'Mi información',
        [CheckoutMessages.CARD_SHIPPING_FORM_SUBTITLE]:
            'Introduce una dirección de envío para que sepamos dónde enviar tu impresora.',
        [CheckoutMessages.CARD_SHIPPING_FORM_SUBTITLE_UPGRADE]:
            'Introduce una dirección de envío para que sepamos dónde enviar tu nueva impresora.',
        [CheckoutMessages.CARD_SHIPPING_RETAIL_FORM_SUBTITLE]:
            'Proporcione una dirección para que podamos completar su compra.',

        [CheckoutMessages.CARD_SHIPPING_FORM_FIRST_NAME]: 'Nombre',
        [CheckoutMessages.CARD_SHIPPING_FORM_LAST_NAME]: 'Apellido',
        [CheckoutMessages.CARD_SHIPPING_FORM_COMPANY]: 'Nombre de la compañía',
        [CheckoutMessages.CARD_SHIPPING_FORM_EMAIL]: 'Correo electrónico',
        [CheckoutMessages.CARD_SHIPPING_FORM_MOBILE_NUMBER]:
            'Número de teléfono móvil',
        [CheckoutMessages.CARD_SHIPPING_FORM_SERIAL_NUMBER]:
            'Nº serie de la impresora',
        [CheckoutMessages.CARD_SHIPPING_FORM_SERIAL_NUMBER_EXAMPLE]:
            'Ejemplo: TH1CH4Z1GT',
        [CheckoutMessages.CARD_SHIPPING_FORM_NO_PO_BOXES]:
            'No se aceptan apartados postales',

        [CheckoutMessages.CARD_BILLING_TITLE]: 'Pago',
        [CheckoutMessages.CARD_BILLING_SUBTITLE]: 'Nada a pagar hoy.',
        [CheckoutMessages.CARD_BILLING_SUBTITLE_UPGRADE]:
            'No hace falta realizar un pago para la actualizacion. Tu cobro mensual continuara al precio indicado.',
        [CheckoutMessages.CARD_BILLING_SUBTITLE_ACTIVATION]:
            'Hoy solo se te cobrará una tarifa de activación de $39.',
        [CheckoutMessages.CARD_BILLING_ADDBILLING]: 'Agregar Pago',
        [CheckoutMessages.CARD_BILLING_PAYPAL]:
            'PayPal vinculado a la cuenta:<b> {account} </b>',
        [CheckoutMessages.CARD_BILLING_LAST_FOUR]: 'XXXX-XXXX-XXXX-{last4}',
        [CheckoutMessages.CARD_BILLING_EXPIRES]: 'Vence: {month}/{year}',
        [CheckoutMessages.CARD_BILLING_FORM_TITLE]: 'Pago',
        [CheckoutMessages.CARD_BILLING_FORM_SUBTITLE]:
            'Introduce la información de tu tarjeta de crédito o débito.\nNo se aceptan tarjetas prepago.',
        [CheckoutMessages.CARD_BILLING_FORM_CCINFO]:
            'Información de la tarjeta de crédito o débito',
        [CheckoutMessages.CARD_BILLING_FORM_NAME]: 'Nombre',
        [CheckoutMessages.CARD_BILLING_FORM_NAME_ERROR]:
            'Por favor, ingrese el nombre que aparece en su tarjeta',
        [CheckoutMessages.CARD_BILLING_FORM_BILLING_ADDRESS]:
            'Dirección de Facturación',
        [CheckoutMessages.CARD_BILLING_FORM_USE_SHIPPING_ADDRESS]:
            'Usar dirección de envío',
        [CheckoutMessages.CARD_BILLING_STRIPE_GENERAL_ERROR]:
            'Lo sentimos, se ha producido un error con tu método de pago. Por favor, inténtalo de nuevo.',
        [CheckoutMessages.CARD_BILLING_STRIPE_INVALID_FUNDING_ERROR]:
            'Lo sentimos, esta opción de pago no está disponible. En este momento no se aceptan tarjetas de crédito y prepago. Por favor, utiliza una tarjeta de débito válida.',

        [CheckoutMessages.ARN_BODY]: `<p>
<b>NADA A PAGAR HOY</b>. Tu forma de pago no se cobrará hoy.

<b>PRUEBA DE 30 DIAS SIN COMPROMISO</b>. Si cancelas tu suscripción dentro de los 30 días posteriores al registro y devuelves la impresora a HP dentro de los 10 días posteriores a la cancelación, no se te cobrará ninguna cuota mensual.

<b>FECHA DE INICIO DEL SERVICIO</b>. Tu servicio comenzará cuando completes tu registro después de recibir tu impresora. Debes completar tu registro dentro de los 30 días posteriores para evitar un cargo por no registro (90€ para Envy, 130€ para Envy Inspire y 250€ para OfficeJet Pro).

<b>RENOVACIÓN AUTOMÁTICA</b>. Una vez que comience tu servicio, se renovará automáticamente y continuará indefinidamente hasta que lo canceles.

<b>CAMBIAR O CANCELAR EL SERVICIO</b>. Puedes cancelar en cualquier momento. En caso de cancelar dentro de los primeros 6 meses de suscripción, se te cobrará una tarifa de cancelación anticipada de 50€. Si cancelas el servicio dentro de los 30 días de prueba, o después de los primeros 6 meses desde el registro, no se aplicará ningún cargo por cancelación anticipada. Debes devolver la impresora a HP. Si no devuelves tu impresora a HP dentro de los 10 días posteriores a la cancelación, se te cobrará una cuota por no devolución. El cargo por la no devolución de la impresora durante el primer año es de 81€ si tienes una Envy, 117€ si tienes una Envy Inspire y 225€ si tienes una Officejet Pro. Este cargo se reducirá progresivamente cada año en función del tiempo que lleves en el servicio. Consulta los términos y condiciones para más información. Las cancelaciones que se produzcan en los 30 días siguientes al registro serán efectivas inmediatamente. Las cancelaciones posteriores a los 30 días del registro entrarán en vigor al final del ciclo de facturación actual. No se emitirán reembolsos por tinta o tóner no utilizados en la suscripción.
        </p>`,
        [CheckoutMessagesB.ARN_BODY]: `<p>
<b>PRUEBA DE 30 DIAS SIN COMPROMISO</b>. Prueba el servicio sin compromiso durante 30 días. Si cancelas tu suscripción en un plazo de 30 días a partir de la fecha de registro y devuelves la impresora a HP en un plazo de 10 días a partir de la cancelación, no se te cobrará ninguna cuota mensual.

<b>FECHA DE INICIO DEL SERVICIO</b>. Tu servicio comenzará cuando completes tu registro después de recibir tu impresora. Debes completar tu registro dentro de los 30 días posteriores para evitar un cargo por no registro (90€ por Envy, 130€ por Envy Inspire o 250€ por OfficeJet Pro).

<b>RENOVACIÓN AUTOMÁTICA</b>. Una vez que comience tu servicio, se renovará automáticamente y continuará indefinidamente hasta que lo canceles.

<b>CAMBIAR O CANCELAR EL SERVICIO</b>. Puedes cancelar en cualquier momento. No hay gastos de cancelación salvo si cancelas el servicio durante los primeros 6 meses y después de haber superado los 30 días de prueba, solo en ese caso se aplica una tarifa de cancelación de 50€.Debes devolver la impresora a HP. Si no devuelves la impresora a HP en un plazo de 10 días a partir de la cancelación, se te cobrará una cuota por no devolución. Durante el primer año el cargo por la no devolución de la impresora es de 81€ para Envy, 117€ para Envy Inspire, y 225€ para OfficeJet Pro, y disminuirá con cada año que estés suscrito; consulte los términos y condiciones para conocer las tarifas detalladas. Puedes solicitar una etiqueta de envío llamando al soporte de HP Instant Ink Platinum.
        </p>`,
        [CheckoutMessagesC.ARN_BODY]: `<p>
<b>PRUEBA DE 30 DIAS SIN COMPROMISO</b>. Prueba el servicio sin compromiso durante 30 días. Si cancelas tu suscripción en un plazo de 30 días a partir de la fecha de registro y devuelves la impresora a HP en un plazo de 10 días a partir de la cancelación, no se te cobrará ninguna cuota mensual.

<b>FECHA DE INICIO DEL SERVICIO</b>. Tu servicio comenzará cuando completes tu registro después de recibir tu impresora. Debes completar tu registro dentro de los 30 días posteriores para evitar un cargo por no registro (90€ por Envy, 130€ por Envy Inspire o 250€ por OfficeJet Pro).

<b>RENOVACIÓN AUTOMÁTICA</b>. Una vez que comience tu servicio, se renovará automáticamente y continuará indefinidamente hasta que lo canceles.

<b>CAMBIAR O CANCELAR EL SERVICIO</b>. Puedes cancelar en cualquier momento. No hay gastos de cancelación salvo si cancelas el servicio durante los primeros 6 meses y después de haber superado los 30 días de prueba, solo en ese caso se aplica una tarifa de cancelación de 50€.Debes devolver la impresora a HP. Si no devuelves la impresora a HP en un plazo de 10 días a partir de la cancelación, se te cobrará una cuota por no devolución. Durante el primer año el cargo por la no devolución de la impresora es de 81€ para Envy, 117€ para Envy Inspire, y 225€ para OfficeJet Pro, y disminuirá con cada año que estés suscrito; consulte los términos y condiciones para conocer las tarifas detalladas. Puedes solicitar una etiqueta de envío llamando al soporte de HP Instant Ink Platinum.
        </p>`,
        [CheckoutMessages.ARN_BODY_NO_OJP]: `<p>
            <b>PRUEBA DE 30 DIAS SIN COMPROMISO</b>. Si cancelas tu suscripción dentro de los 30 días posteriores al registro y devuelves la impresora a HP dentro de los 10 días posteriores a la cancelación, no se te cobrará ninguna cuota mensual y se te reembolsarán los 20 € que pagaste al registrarte.
                
            <b>FECHA DE INICIO DEL SERVICIO</b>. Tu servicio comenzará cuando completes tu inscripción después de recibir su impresora. Debe completar tu inscripción dentro de los 30 días para tu registro que te cobre por la impresora (90€ para Debes Envy, 130€ para registro Envy Inspire).
                
            <b>RENOVACIÓN AUTOMÁTICA</b>. Una vez que comience tu servicio, se renovará automáticamente y continuará indefinidamente hasta que lo canceles. Tu método de pago registrado se cargará automáticamente cada mes al final de cada ciclo de facturación. Tus cargos mensuales se basarán en la impresora y el plan que seleccionaste, reflejados en la sección “Tu plan" anterior, que incluye un cargo fijo por las páginas incluidas en tu plan y un posible cargo por exceso por las páginas que imprimas en durante el mes.
                
            <b>CAMBIAR O CANCELAR EL SERVICIO</b>. Puedes cancelar en cualquier momento. En caso de cancelar dentro de los primeros 6 meses de suscripción, se te cobrará una tarifa de cancelación anticipada de 50€. Si cancelas el servicio dentro de los 30 días de prueba, o después de los primeros 6 meses desde el registro, no se aplicará ningún cargo por cancelación anticipada. Debes devolver la impresora a HP. Si no devuelves tu impresora a HP dentro de los 10 días posteriores a la cancelación, se te cobrará una cuota por no devolución. El cargo por la no devolución de la impresora durante el primer año es de 81€ si tienes una Envy, 117€ si tienes una Envy Inspire y 225€ si tienes una Officejet Pro. Este cargo se reducirá progresivamente cada año en función del tiempo que lleves en el servicio. Consulta los términos y condiciones para más información. Las cancelaciones que se produzcan en los 30 días siguientes al registro serán efectivas inmediatamente. Las cancelaciones posteriores a los 30 días del registro entrarán en vigor al final del ciclo de facturación actual. No se emitirán reembolsos por tinta o tóner no utilizados en la suscripción.
        </p>`,

        [CheckoutMessages.ARN_BODY_ACTIVATION]: ' ',

        [CheckoutMessages.ARN_CONFIRMATION_LABEL]: 'He leído y acepto los ',
        [CheckoutMessages.ARN_CONFIRMATION_LINK]:
            'Términos de Servicio de HP Instant Ink Platinum',
        [CheckoutMessages.ARN_TITLE]: 'Aviso de Renovación Automática',
        [CheckoutMessages.ARN_COMPLETE]: 'Confirmar Suscripción',
        [CheckoutMessages.ARN_BODY_UPGRADE]:
            '<p><b>FIRST 30 DAYS.</b> Once you confirm your printer upgrade, your 24-month subscription will restart. You must complete your enrollment within 30 days to avoid being charged for the printer ($160 for Envy, $200 for Envy Inspire, and $270 for OfficeJet Pro). Complete enrollment by calling the support number at the bottom of this box.</p><p><b>AUTOMATIC RENEWAL.</b> Once your service starts, it will automatically renew and continue indefinitely until you cancel. Your payment method on file will be automatically billed monthly at the end of each bill cycle. Your monthly charges will be based on the printer you selected, your current plan reflected on the previous page as well as within your Dashboard, and lastly whether you have opted into the optional paper add-on. This includes a fixed charge for the pages included in your plan and a potential overage charge for pages you print in excess of your plan during the month.</p><p><b>CHANGE OR CANCEL SERVICE.</b> You can change or cancel the service at any time by visiting <a>www.hpinstantink.com</a>, signing in, and selecting “Cancel” on your dashboard or by calling support. Beyond the 30-day trial, your cancellation will go into effect on the last day of your current billing cycle. After you cancel, HP will remotely disable the subscription cartridge, so you will no longer be able to print with it. If you cancel within the first year, you will be charged an early cancelation fee of $160 for Envy, $200 for Envy Inspire, and $270 for OfficeJet Pro. If you cancel between the first and second year, you will be charged an early cancelation fee of $80 for Envy, $100 for Envy Inspire, and $135 for OfficeJet Pro. No refunds will be issued for any unused ink or toner.</p><p><b> Platinum support: 1-888-447-0148</b></p>',

        [CheckoutMessages.ARN_COMPLETE_UPGRADE]: 'Continue with Upgrade',

        // Survey Modal
        [CheckoutMessages.SURVEY_TITLE]: 'Sentimos que te vayas.',
        [CheckoutMessages.SURVEY_SUBTITLE]:
            '¿Tienes un par de minutos para darnos tu opinión?',
        [CheckoutMessages.SURVEY_GIFTCARD]:
            'Gana una tarjeta de regalo de su\nelección por sus respuestas completas.',
        [CheckoutMessages.SURVEY_BUTTON]: 'Comenzar encuesta',
        [CheckoutMessages.SURVEY_LINK]: 'No, gracias',

        // Error Messages

        [CheckoutMessages.CARD_SHIPPING_FORM_FIRST_NAME_ERROR]:
            'Por favor, ingrese su nombre',
        [CheckoutMessages.CARD_SHIPPING_FORM_LAST_NAME_ERROR]:
            'Por favor, ingrese su apellido',
        [CheckoutMessages.CARD_COMMON_ZIP_ERROR]:
            'Por favor, ingrese su código postal',
        [CheckoutMessages.CARD_COMMON_ZIP_ERROR_INVALID_FORMAT]:
            'Por favor, ingrese un código postal válido',
        [CheckoutMessages.CARD_COMMON_ZIP_ERROR_MAXLENGTH]:
            'El código postal no debe tener más de 5 caracteres',
        [CheckoutMessages.CARD_COMMON_ZIP_ERROR_BLACKLIST]:
            'Disculpe, no hacemos envíos al código {zip}',
        [CheckoutMessages.CARD_COMMON_ZIP_UNAVAILABLE]:
            'De momento no hacemos envíos a este código postal',
        [CheckoutMessages.CARD_COMMON_STATE_ERROR]:
            'Por favor, elija un estado',
        [CheckoutMessages.CARD_COMMON_CITY_ERROR]:
            'Por favor, elija una ciudad',
        [CheckoutMessages.CARD_COMMON_ADDRESS_ONE_ERROR]:
            'Por favor, ingrese una dirección',
        [CheckoutMessages.CARD_SHIPPING_FORM_EMAIL_ERROR]:
            'Por favor, ingrese su correo electrónico',
        [CheckoutMessages.CARD_SHIPPING_FORM_EMAIL_ERROR_FORMAT]:
            'Por favor, ingresa un formato de correo electrónico válido. Se permiten caracteres especiales.',
        [CheckoutMessages.CARD_SHIPPING_FORM_MOBILE_PHONE_ERROR]:
            'Por favor, ingrese su número telefónico',
        [CheckoutMessages.CARD_SHIPPING_FORM_SERIAL_NUMBER_ERROR]:
            'Por favor, ingrese el número de serie de su impresora',
        [CheckoutMessages.CARD_SHIPPING_FORM_MOBILE_ERROR_PHONE_NUMBER_BELOW_ZERO]:
            'El número telefónico no puede ser un valor negativo',
        [CheckoutMessages.CARD_BILLING_FORM_GENERAL_ERROR]:
            'Ocurrió un error tratando de procesar su pago',
        [CheckoutMessages.CHECKOUT_FAILED_POST]:
            'Hubo un problema con tu medio de pago, por favor intenta con otra tarjeta de débito o crédito o contacta a tu banco',

        // Shop Comparison

        [CheckoutMessages.SHOP_COMPARISON_TITLE]: 'Compara opciones de compra',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_TITLE]:
            'Suscribirse al servicio\nHP Instant Ink Platinum',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_ONE]:
            'Incluye una impresora',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_TWO]:
            'Garantía ilimitada mientras mantengas tu\nsuscripción',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_THREE]:
            'Atención al cliente personalizada de lunes a\ndomingo',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_FOUR]:
            'Recibe automáticamente tus cartuchos en\ncasa solo cuando los necesites',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_FIVE]:
            '30 días de prueba sin compromiso',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_SIX]:
            'Opción de renovar la impresora cada 3 años',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_SEVEN]:
            'Reemplazo de la impresora al siguiente día\nlaborable',
        [CheckoutMessages.SHOP_COMPARISON_SUBSCRIBE_ITEM_EIGHT]: 'Envío gratis',
        [CheckoutMessages.SHOP_COMPARISON_BUY_TITLE]:
            'Comprar únicamente\nuna impresora',
        [CheckoutMessages.SHOP_COMPARISON_BUY_ITEM_ONE]: 'Incluye la impresora',
        [CheckoutMessages.SHOP_COMPARISON_BUY_ITEM_TWO]: '1 año de garantía',
        [CheckoutMessages.SHOP_COMPARISON_BUY_ITEM_THREE]:
            'Atención al cliente de lunes a viernes',

        // Sayan printer not available
        [CheckoutMessages.SAYAN_MODAL_TITLE]:
            'Este modelo de impresora aún\nno está disponible a través de\nHP Instant Ink Platinum',
        [CheckoutMessages.SAYAN_MODAL_CONTINUE_SUBSCRIPTION]:
            'Si estás interesado en una\nimpresora con una suscripción\ncon todo incluido, por favor elige\nuna impresora diferente.',
        [CheckoutMessages.SAYAN_MODAL_CONTINUE_BUY]:
            'Si estás interesado en\ncomprar una impresora HP\nSmart Tank, por favor visita\nnuestra tienda HP Store',
        [CheckoutMessages.SAYAN_MODAL_BUTTON_BUY]: 'Comprar impresora',
        [CheckoutMessages.SAYAN_MODAL_DISCLAIMER]:
            'Estamos evaluando la inclusión de la impresora HP Smart Tank {modelNumber} en el servicio de suscripción de impresión HP Instant Ink Platinum.\nLamentamos las molestias ocasionadas.',
        [CheckoutMessages.SAYAN_MODAL_CONTINUE_BUTTON]:
            'Suscribirse con una impresora distinta',
    },
};

// TODO: Make it global around all app and add typesafety to useFormat

export const checkoutMessagesValues = ({
    plan = ' ',
    pages = ' ',
    morePaper = ' ',
    month = ' ',
    year = ' ',
    last4 = ' ',
    serialNumber = ' ',
    zip = ' ',
    account = ' ',
    modelNumber = ' ',
}) => ({
    [CheckoutMessages.CARD_PLAN_NAME]: {
        plan,
    },
    [CheckoutMessages.CARD_PLAN_INCLUDES_PAGES]: {
        pages,
    },
    [CheckoutMessages.CARD_PLAN_MORE_PAPER]: {
        morePaper,
    },
    [CheckoutMessages.CARD_BILLING_EXPIRES]: {
        month,
        year,
    },
    [CheckoutMessages.CARD_BILLING_LAST_FOUR]: {
        last4,
    },
    [CheckoutMessages.CARD_BILLING_PAYPAL]: { account },
    [CheckoutMessages.CARD_SHIPPING_SERIAL_NUMBER]: {
        serialNumber,
    },
    [CheckoutMessages.CARD_COMMON_ZIP_ERROR_BLACKLIST]: {
        zip,
    },
    [CheckoutMessages.SAYAN_MODAL_DISCLAIMER]: {
        modelNumber,
    },
});
